import './numbers.scss'
import { loadSvg } from 'js/utility/image.js'
import { tweenNumbers } from './numbers-tweens.js'

export default {
    name: 'numbers',

    data: {
        intObserver: null,
        tweenComplete: true
    },

    mounted () {
        this.loadIcons()

        this.intObserver = new IntersectionObserver(entries => {
            if (entries && entries.length) {
                if(entries[0].isIntersecting) {
                    this.tweenNumbers()
                }
            }
        })
        this.intObserver.observe(this.$el)
    },

    methods: {
        loadIcons () {
            if (this.numbers && this.numbers.length) {
                this.numbers.forEach(number => {
                    if (number.icon) {
                        Promise.resolve()
                            .then(() => loadSvg(number.icon))
                            .then(svg => { number.icon_html = svg.outerHTML })
                    }
                })
            }
        },

        tweenNumbers() {
            if (!this.tweenComplete) {
                return
            }
            if (this.numbers && this.numbers.length) {
                const tweens = this.numbers.map(number => tweenNumbers.call(this, number))
                this.tweenComplete = false
                Promise.all(tweens).then(() => { this.tweenComplete = true })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./app/theme/components/numbers/numbers.js